/**
 * Handle of a JOOR app as published on the Shopify app store. Branded so it
 * cannot be confused with a `ShopifyAppName`: that is a string enum, so without
 * the brand `getShopifyAppUrl(ShopifyAppName.BRAND_SYNC)` would compile happily
 * and silently produce `apps.shopify.com/BRAND_SYNC`.
 */
export type ShopifyAppHandle = string & { readonly __brand: 'ShopifyAppHandle' }

const asHandle = (value: string | undefined) =>
  value as ShopifyAppHandle | undefined

/**
 * Read lazily: `process.env` is inlined at build time in the app, but tests set
 * these vars at runtime, and a module-level read would freeze the wrong value.
 */
export const getBrandSyncAppHandle = () =>
  asHandle(process.env.REACT_APP_SHOPIFY_BRAND_SYNC_APP_NAME)

export const getRetailerSyncAppHandle = () =>
  asHandle(process.env.REACT_APP_SHOPIFY_APP_NAME)

export const getShopifyAppUrl = (appHandle: ShopifyAppHandle | undefined) =>
  `https://apps.shopify.com/${appHandle}`

export const getShopifyAppPricingUrl = (
  shopSlug: string,
  appHandle: ShopifyAppHandle | undefined,
) =>
  `https://admin.shopify.com/store/${shopSlug}/charges/${appHandle}/pricing_plans`
